import "./tile.scss";
      const mappedNames = {"tile":"_tile_121jy_1","image":"_image_121jy_6","image-placeholder":"_image-placeholder_121jy_7","tile-pos-left":"_tile-pos-left_121jy_26","tile-pos-right":"_tile-pos-right_121jy_30","tile-pos-far-right":"_tile-pos-far-right_121jy_35"};

      function mapName(name) {
        if (!(name in mappedNames)) {
          // throw new Error("Unknown class name '" + name + "'.");
          return null;
        }

        return mappedNames[name];
      }

      export default function(...args) {
        const results = [];
        for (const arg of args) {
          if (typeof arg === "string") {
            const mappedName = mapName(arg);
            if (mappedName) results.push(mappedName);
          } else if (typeof arg === "object") {
            for (const [name, active] of Object.entries(arg)) {
              const mappedName = mappedNames[name];
              if (active && mappedName) results.push(mappedName);
            }
          }
        }

        return results.join(" ");
      }
      